<div class="modal-header">
    <h4 class="modal-title" id="sucursal-selector-title">Seleccionar Sucursal</h4>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    <form (ngSubmit)="confirm()" #form="ngForm">
        <div class="mb-3">
            <label for="sucursalSelect" class="form-label required">Sucursal</label>
            <app-select name="sucursal" id="sucursal" [required]="true"

                placeholder="-- Selecione una sucursal --"
                [items]="sucursales.value() || []" bindLabel="nombre" bindValue="sucursalId"
                [notFoundText]="'No se encontraron sucursales'"
                [(ngModel)]="selectedSucursal">
            </app-select>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!form.valid">Aceptar</button>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Cancelar</button>
</div>